import { useFingerprint } from "@src/composables/useFingerprint";

const state = {
    requestId: null,
    requestIdAt: null
}

const getters = {
    getRequestId: state => state.requestId
}

const mutations = {
    setRequestId(state, payload) {
        state.requestId = payload.requestId
        state.requestIdAt = payload.requestIdAt
    }
}

const actions = {
    async fetchFingerprint({ commit }) {
        const requestId = await useFingerprint();
        commit('setRequestId', {
            requestId,
            requestIdAt: Date.now()
        });
    }
}

export {
    state,
    getters,
    mutations,
    actions
}
